/**
 * getCustomizedAdConfig
 * Based on config from the Portal, generate the sizeMapping for the ad
 *
 * @param {Boolean} desktopRule
 * @param {Boolean} mobileRule
 * @return {array} customizedAdConfig
 */
export const getCustomizedAdConfig = ({
  desktopRule,
  mobileRule,
}) => {
  const customizedAdConfig = [];

  customizedAdConfig.slotSize = [[300, 250], 'fluid'];
  customizedAdConfig.sizeMapping = [
    {
      viewport: [0, 0],
      slot: mobileRule ? [[300, 250], 'fluid'] : [],
    },
    {
      viewport: [760, 0],
      slot: mobileRule ? [[728, 90], [300, 250], 'fluid'] : [],
    },
    {
      viewport: [980, 0],
      slot: desktopRule ? [[970, 250], [970, 90], [728, 90], 'fluid'] : [],
    },
  ];
  customizedAdConfig.ampSlotSize = mobileRule ? [300, 250] : [];
  customizedAdConfig.ampSizeMapping = [
    {
      viewport: [0, 0],
      slot: mobileRule ? [300, 250] : [],
    },
  ];

  return customizedAdConfig;
};
